import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { host } from '../../App';
import Axios from 'axios'
import "./Received_raw_material.css";

function Received_raw_material() {
  var [del, setdel] = useState(1);
  var int = 4;
  var [postList, setPostList] = useState([]);
  var [PoNo, setPoNo] = useState({});
  var [poNo, setpoNo] = useState([]);
  var [Item_Desc, setItem_Desc] = useState("");
  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState('2026-01-01');
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  var [Supplier, setSupplier] = useState({});
  var [ItemNo, setItemNo] = useState("");
  var [Customers, setCustomers] = useState([]);
  var [partNo, setpartNo] = useState([]);
  var [order, setOrder] = useState("1");
  var [Button, setButton] = useState("Received Order");
  var [Button_logic, setButton_logic] = useState(false);
  const [Edit, setEdit] = useState(false);
  var Total = 0;

  const [data, setData] = useState([{ PO_No: "", Item_No: "", ReceivedQty: "", ActualReceiveddate: Date1.toISOString().slice(0, 10), Invoice_cost: "", Invoice_No: "", Unit_cost: "", PO_CURRENCY: "", Supplier: "", Item_Description: "", QTY: "", Unit_price_po: "", ETA: "", GRN_No: "", Unit: "" },]);

  var token = (window.localStorage.getItem("acessToken"));

  useEffect(() => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/search/${JSON.stringify(PoNo)},${JSON.stringify(ItemNo)},${Postartdate},${Poenddate},${JSON.stringify(Supplier)},${order},${token},${JSON.stringify(Item_Desc)}`).then((data) => {
      const transformedData = data.data.map((item) => ({
        SrNo: item.SrNo || "",
        PO_No: item.PO_No || "",
        PO_Date: item.PO_Date || "",
        Item_No: item.Item_No || "",
        ReceivedQty: item.ReceivedQty || "",
        ActualReceiveddate: Date1.toISOString().slice(0, 10),
        Invoice_cost: item.Unit_Cost_Invoice || "0",
        Invoice_No: item.Invoice_No || "0",
        Item_Description: item.Item_Description || "",
        Supplier: item.Supplier || "",
        Comments: item.Comments || "",
        Unit_cost: item.COST || "",
        Unit_price_po: item.Unit_cost || "",
        PO_CURRENCY: item.PO_CURRENCY || "",
        QTY: item.Remained_parts || "0",
        PO_QTY: item.QTY || "0",
        ETA: item.ETA.slice(0, 10) || "",
        Unit: item.Unit || "",
        GRN_No: item.GRN_No || ""
      }));
      setData(transformedData);
    })
  }, [PoNo, poNo, Item_Desc, Postartdate, Poenddate, Supplier, ItemNo, Customers, partNo, order]);

  useEffect(() => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/pono/${token}`).then((data) => {
      setpoNo(data.data)
    });
  }, [])

  useEffect(() => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/suppliers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [])

  useEffect(() => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/itemno/${token}`).then((data) => {
      setpartNo(data.data)
    });
  }, [])

  const search = () => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/search/${JSON.stringify(PoNo)},${JSON.stringify(ItemNo)},${Postartdate},${Poenddate},${JSON.stringify(Supplier)},${order},${token},${JSON.stringify(Item_Desc)}`).then((data) => {
      const transformedData = data.data.map((item) => ({
        SrNo: item.SrNo || "",
        PO_No: item.PO_No || "",
        PO_Date: item.PO_Date || "",
        Item_No: item.Item_No || "",
        ReceivedQty: item.ReceivedQty || "",
        ActualReceiveddate: Date1.toISOString().slice(0, 10),
        Invoice_cost: item.Unit_Cost_Invoice || "0",
        Invoice_No: item.Invoice_No || "0",
        Item_Description: item.Item_Description || "",
        Supplier: item.Supplier || "",
        Comments: item.Comments || "",
        Unit_cost: item.COST || "",
        Unit_price_po: item.Unit_cost || "",
        PO_CURRENCY: item.PO_CURRENCY || "",
        QTY: item.Remained_parts || "0",
        PO_QTY: item.QTY || "0",
        ETA: item.ETA.slice(0, 10) || "",
        GRN_No: item.GRN_No || ""
      }));
      setData(transformedData);
    })
  }

  const [changedRows, setChangedRows] = useState(new Set());
  const handleUpdate = (e, index, key) => {
    const { value } = e.target;
    updateData(index, key, value);
  };

  const [changedRows_PO, setChangedRows_PO] = useState(new Set());
  const handleUpdate_PO = (e, index, key) => {
    const { value } = e.target;
    updateData_PO(index, key, value);
  };

  const updateData_PO = (index, key, value) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;
      return newData;
    });
    setChangedRows_PO(prevRows => new Set(prevRows).add(index));
  };

  const updateData = (index, key, value) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;

      const isValidDate = (date) => date && date !== '0000-00-00' && !isNaN(new Date(date).getTime());

      const isValid = (row) =>
        row.ReceivedQty &&
        isValidDate(row.ActualReceiveddate);

      const iscostValid = (row) =>
        row.Invoice_cost > 0 &&
        row.Invoice_No > 0;

      if (isValid(newData[index])) {
        setChangedRows(prevRows => {
          const newSet = new Set(prevRows);
          newSet.add(index);
          return newSet;
        });
      } else if (iscostValid(newData[index])) {
        setChangedRows(prevRows => {
          const newSet = new Set(prevRows);
          newSet.add(index);
          return newSet;
        });
      }
      return newData;
    });
  };

  const ToggleEdit = () => {
    setEdit(!Edit);
  }

  const Delete = (SrNo) => {
    setdel(del = del + 1)
    Axios.delete(`https://` + host + `/api/ReceivedRawMaterial/Delete/${SrNo},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 1000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
          });
          search();
        }
      })
      .catch(function (error) {
        console.log(error.response);
      });
  };

  const Update = () => {
    setdel(del = del + 1)

    const changedData = [...changedRows].map(i => data[i]);
    const invalidGRN = changedData.some(
      row => row.Supplier === "HARDWOODS" && !row.GRN_No || row.Supplier === "COMMONWEALTH PLYWOOD LTD" && !row.GRN_No
    );
    const invalidDate = changedData.some(row => {
      const d = row.ActualReceiveddate;
      if (!d || d === "0000-00-00") return true;
      const parsed = new Date(d);
      return isNaN(parsed.getTime());
    });

    if (invalidGRN) {
      alert("Please enter LOT No");
    }

    if (changedData.length > 0 && !invalidGRN) {
      Axios.post(`https://` + host + `/Raw_material/Receiveddata/Update`, { changedData: JSON.stringify(changedData), token: token })
        .then((response) => {
          if (response.status === 200) {
            const numberInputs = document.querySelectorAll('input[type="number"], input[type="date"], input[type="text"]');
            numberInputs.forEach(input => {
              input.value = '';
            });
            toast.success(response.data.message, {
              autoClose: 3000,
              position: toast.POSITION.TOP_RIGHT,
              style: { fontSize: '24px', borderRadius: '10px' },
            });
            search();
          }
        })
        .catch(function (error) {
          console.log(error.response);
        })
    } else if (changedData.length < 0 || changedData.length === 0 || invalidGRN || invalidDate) {
      toast.error("No Valid Data !", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '24px', borderRadius: '10px' },
      });
    }
  };

  const Update_PO = () => {
    setdel(del = del + 1)
    const changedData = [...changedRows_PO].map(index => {
      return data[index];
    });

    Axios.post(`https://` + host + `/Raw_material/PO/Update`, { changedData: JSON.stringify(changedData), token: token })
      .then((response) => {
        if (response.status === 200) {
          const numberInputs = document.querySelectorAll('input[type="number"]');
          numberInputs.forEach(input => {
            input.value = '';
          });
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          });
          search();
          setEdit(false);
        }
      })
      .catch(function (error) {
        console.log(error.response);
      });
  };

  return (
    <div className="rrmPage">
      <ToastContainer />

      <div className="rrmCard">
        <div className="rrmHeader">
          <div>
            <div className="rrmTitle">RECEIVED RAW MATERIAL</div>
            <div className="rrmSub">Search, receive, update, and manage PO lines</div>
          </div>

          <div className="rrmHeaderActions">
            <Link to="/Historyrawmaterial">
              <input type="button" class="btn btn-success rrmBtn" defaultValue="History Raw Material" />
            </Link>
            <input type="button" class="btn btn-success rrmBtn" defaultValue="Update Raw Material" onClick={() => { ToggleEdit() }} />
            <Link to="/graph_RRM">
              <input type="button" class="btn btn-primary rrmBtn" defaultValue="Graph Report" />
            </Link>
          </div>
        </div>

        {/* Filters */}
        <div className="rrmFilters">
          <div className="rrmField">
            <label>PO NO</label>
            <input type='text' class="form-control form-rounded" placeholder='PO NO' list="PoNo"
              onChange={(e) => { setPoNo(e.target.value) }} onSelect={search} />
            <datalist id="PoNo">
              <option></option>
              {poNo.map(x => <option>{x.PO_No}</option>)}
            </datalist>
          </div>

          <div className="rrmField">
            <label>Item No</label>
            <input type='text' class="form-control form-rounded" placeholder='Item No' list='Itemno'
              onChange={(e) => { setItemNo(e.target.value) }} onSelect={search} />
            <datalist id="Itemno">
              <option></option>
              {partNo.map(x => <option>{x.Item_No}</option>)}
            </datalist>
          </div>

          <div className="rrmField">
            <label>Item Description</label>
            <input type='text' class="form-control form-rounded" placeholder='Item DESCRIPTION' list="Itemdesc"
              onChange={(e) => { setItem_Desc(e.target.value.replace(/[{"''"}]/g, '')); }} onSelect={search} />
            <datalist id="Itemdesc">
              <option></option>
              {postList.map(x => <option>{x.Item_Description}</option>)}
            </datalist>
          </div>

          <div className="rrmField">
            <label>Supplier</label>
            <input type='text' class="form-control form-rounded" placeholder='Supplier' list='Suppliers'
              onChange={(e) => { setSupplier(e.target.value) }} onSelect={search} />
            <datalist id="Suppliers">
              <option></option>
              {Customers.map(x => <option>{x.Supplier}</option>)}
            </datalist>
          </div>

          <div className="rrmField">
            <label>Start Date</label>
            <input type='date' class="form-control form-rounded" defaultValue={Postartdate}
              onChange={(e) => { setPoStartdate(e.target.value) }} onSelect={search} />
          </div>

          <div className="rrmField">
            <label>End Date</label>
            <input type='date' class="form-control form-rounded" defaultValue={Date1.toISOString().slice(0, 10)}
              onChange={(e) => { setPoEnddate(e.target.value) }} onSelect={search} />
          </div>

          <div className="rrmField">
            <label>Order Filter</label>
            <select
              type="select"
              class="form-control form-rounded"
              id="order"
              name="order"
              onChange={(e) => {
                setOrder(e.target.value);
                order = e.target.value;
                search();
              }}
            >
              <option value="1">Open Orders</option>
              <option value="0"> Open/Closed Orders</option>
            </select>
          </div>
        </div>
        <br />
        {/* Table */}
        <div id="scroll_rrm">
          {Edit ? (
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>PO<br />NO</th>
                  <th>ITEM<br />NO</th>
                  <th>PO<br />DATE</th>
                  <th>ITEM<br />DESC</th>
                  <th>SUPPLIER</th>
                  <th>PO<br />QTY</th>
                  <th>ETA</th>
                  <th>CURR</th>
                  <th>UNIT<br />COST</th>
                  <th>COMMENTS</th>
                  <th>UPDATE</th>
                  <th>DELETE</th>
                </tr>
              </thead>

              {data.map((val, index) => (
                <tbody key={index} className={val.Unit_price_po > val.Unit_cost ? "highlight-row" : ""}>
                  <tr key={`${val.PO_No}-${val.Item_No}`}>
                    <td>{val.PO_No}</td>
                    <td>{val.Item_No}</td>
                    <td>
                      <input type="date" class="form-control-plaintext" id="PO_Date"
                        Value={val.PO_Date ? (data[index].PO_Date.slice(0, 10)) : null}
                        onBlur={(e) => handleUpdate_PO(e, index, 'PO_Date')}
                      />
                    </td>
                    <td>
                      <input type="text" class="form-control-plaintext" id="PO_Date"
                        Value={data[index].Item_Description}
                        onBlur={(e) => handleUpdate_PO(e, index, 'Item_Description')}
                      />
                    </td>
                    <td>
                      <input type="text" class="form-control-plaintext" id="PO_Date"
                        Value={data[index].Supplier}
                        onBlur={(e) => handleUpdate_PO(e, index, 'Supplier')}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control-plaintext"
                        id="PO_Date"
                        Value={data[index].PO_QTY}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers
                          if (!/^\d*\.?\d*$/.test(value)) {
                            alert("Numbers only");
                            return;
                          }
                        }}
                        onBlur={(e) => handleUpdate_PO(e, index, 'PO_QTY')}
                      />
                    </td>
                    <td>
                      <input type="date" class="form-control-plaintext" id="PO_Date"
                        Value={data[index].ETA.slice(0, 10)}
                        onBlur={(e) => handleUpdate_PO(e, index, 'ETA')}
                      />
                    </td>
                    <td>
                      <input type="text" class="form-control-plaintext" id="PO_Date"
                        Value={data[index].PO_CURRENCY}
                        onBlur={(e) => handleUpdate_PO(e, index, 'PO_CURRENCY')}
                        list='currency'
                      />
                      <datalist id='currency'>
                        <option>CAD</option>
                        <option>USD</option>
                      </datalist>
                    </td>
                    <td>
                      <input type="text" class="form-control-plaintext" id="PO_Date"
                        Value={data[index].Unit_price_po}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers
                          if (!/^\d*\.?\d*$/.test(value)) {
                            alert("Numbers only");
                            return;
                          }
                        }}
                        onBlur={(e) => handleUpdate_PO(e, index, 'Unit_price_po')}
                      />
                    </td>
                    <td id="comment">
                      <input type="text" class="form-control-plaintext"
                        Value={data[index].Comments}
                        onBlur={(e) => handleUpdate_PO(e, index, 'Comments')}
                      />
                    </td>
                    <td>
                      <button className="btn btn-success" onClick={() => Update_PO()}>
                        Update PO
                      </button>
                    </td>
                    <td>
                      <button className="btn btn-danger"
                        onClick={() => window.confirm('Are you sure you want to delete this Entry ?') && Delete(val.SrNo)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          ) : (
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>PO NO</th>
                  <th>ITEM NO</th>
                  <th>PO<br />DATE</th>
                  <th>ITEM<br />DESCRIPTION</th>
                  <th>SUPPLIER</th>
                  <th>REM.<br />QTY</th>
                  <th>UNIT</th>
                  <th>ETA</th>
                  <th>RECEIVING<br />QTY</th>
                  <th>RECEIVING<br />DATE</th>
                  <th>CURR</th>
                  <th>UNIT<br />PO $</th>
                  <th>AMT<br />PO $</th>
                  <th>UNIT<br />DB $</th>
                  <th>INVOICE<br />COST</th>
                  <th>INVOICE<br />NO</th>
                  <th>GRN<br />NO</th>
                  <th>LOT<br />NO</th>
                  <th>CUST</th>
                  <th>SHIP</th>
                  <th>COMMENTS</th>
                  <th>UPDATE</th>
                  <th>DELETE</th>
                </tr>
              </thead>
              {data.map((val, index) => {
                Total = data.reduce((acc, val) => acc + (val.Unit_price_po * val.QTY), 0);
                return (
                  <tbody key={index}>
                    <tr
                      key={`${val.PO_No}-${val.Item_No}`}
                      className={
                        val.Unit_price_po > val.Unit_cost
                          ? "highlight-row"
                          : val.QTY < val.PO_QTY && val.Invoice_No == 0 || val.QTY < val.PO_QTY && val.Invoice_cost == 0
                            ? "orange-background"
                            : ""
                      }
                    >
                      <td>{val.PO_No}</td>
                      <td>{val.Item_No}</td>
                      <td>{val.PO_Date ? val.PO_Date.slice(0, 10) : ''}</td>
                      <td>{val.Item_Description}</td>
                      <td>{val.Supplier}</td>
                      <td>{val.QTY}</td>
                      <td>{val.Unit}</td>
                      <td>{val.ETA ? val.ETA.slice(0, 10) : ''}</td>

                      <td>
                        <input
                          type="text"
                          class="form-control-plaintext"
                          id="Receivedqty"
                          Value={data[index].ReceivedQty}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only numbers
                            if (!/^\d*\.?\d*$/.test(value)) {
                              alert("Numbers only");
                              return;
                            }
                          }}
                          onBlur={(e) => {
                            if (e.target.value > val.QTY) {
                              window.alert("Received QTY cannot exceed PO QTY");
                              const newData = [...data];
                              newData[index].ReceivedQty = '';
                              newData[index].ActualReceiveddate = Date1.toISOString().slice(0, 10);
                              setData(newData);
                            } else {
                              handleUpdate(e, index, 'ReceivedQty');
                            }
                          }}
                        />
                      </td>

                      <td>
                        <input
                          type="date"
                          class="form-control-plaintext"
                          Value={data[index].ActualReceiveddate}
                          onBlur={(e) => handleUpdate(e, index, 'ActualReceiveddate')}
                        />
                      </td>

                      <td>{val.PO_CURRENCY}</td>
                      <td>${val.Unit_price_po}</td>
                      <td>${(val.QTY * val.Unit_price_po).toFixed(2)}</td>
                      <td>${val.Unit_cost}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control-plaintext"
                          Value={data[index].Invoice_cost}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only numbers and decimal
                            if (!/^\d*\.?\d*$/.test(value)) {
                              alert("Numbers only");
                              return;
                            }

                          }}
                          onBlur={(e) => handleUpdate(e, index, 'Invoice_cost')}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control-plaintext"
                          Value={data[index].Invoice_No}
                          onBlur={(e) => handleUpdate(e, index, 'Invoice_No')}
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          class="form-control-plaintext"
                          Value={data[index].GRN_No}
                          onBlur={(e) => handleUpdate(e, index, 'GRN_No')}
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          class="form-control-plaintext"
                          Value={data[index].GRN_No}
                          onBlur={(e) => handleUpdate(e, index, 'GRN_No')}
                        />
                      </td>

                      <td>{data[index].CUSTOMS}</td>
                      <td>{data[index].SHIPPING}</td>

                      <td>
                        <input
                          type="text"
                          class="form-control-plaintext"
                          Value={data[index].Comments}
                          onBlur={(e) => handleUpdate(e, index, 'Comments')}
                        />
                      </td>

                      <td>
                        <button className="btn btn-success" onClick={() => { Update(); }}>
                          Update
                        </button>
                      </td>

                      <td>
                        <button className="btn btn-danger"
                          onClick={() => window.confirm('Are you sure you want to delete this Entry ?') && Delete(val.SrNo)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                )
              })}
            </table>
          )}
        </div>
      </div>
    </div>
  )
}

export default Received_raw_material
